import { reactive, toRefs, ref, watch, computed } from "vue";
import DeviceStateHistoryLocal from "@/views/deviceManage/deviceRunData/components/DeviceStateHistory.vue";
import { useRoute } from "vue-router";
export default {
  name: "DeviceStateAEP",
  props: ["deviceId", "productId", "deviceState", "actType"],
  components: {
    "actuator-state-history": DeviceStateHistoryLocal
  },
  setup(props) {
    const zxqShowHistory = ref();
    const route = useRoute();
    const valveSwitch = ref(props.deviceState.valuePos === 1 ? 1 : 0);
    const state = reactive({
      runData: {
        bottlePressure: '-',
        bottleNumber: '-',
        humidity: '-',
        temp: '-',
        valuePos: '-',
        valuePosDesc: '-',
        valueOpenPos: '-',
        internBatVol: '-',
        externalBatVol: '-',
        prePipePre: '-',
        postPipePre: '-',
        rebootCnt: '-',
        gasConc: '-',
        waterLevel: '-',
        torqueVal: '-'
      }
    });
    const methods = reactive({
      showDetailDialog(indi, unit, name) {
        let row = {
          id: "",
          indicator: indi,
          opstartTime: "",
          opEndTime: "",
          unit: unit,
          legend: name
        };
        zxqShowHistory.value.show(row, "历史数据");
      }
    });

    // AEP: valuePos == 5 或 6 为异常
    const isValveAbnormal = computed(() => state.runData.valuePos == 5 || state.runData.valuePos == 6);
    watch(() => props.deviceState, val => {
      state.runData = {
        ...props.deviceState
      };
      valveSwitch.value = props.deviceState.valuePos === 1 ? 1 : 0;
      let valueOpenPos = "";
      if (props.actType == 1) {
        valueOpenPos = state.runData.valuePos == 1 ? 100 : 0;
      } else {
        valueOpenPos = state.runData.valueOpenPos == null ? '-' : state.runData.valueOpenPos;
      }
      state.runData.valueOpenPos = valueOpenPos;
    }, {
      deep: true
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      zxqShowHistory,
      valveSwitch,
      isValveAbnormal
    };
  }
};